var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgU11 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.00 0.00 343.00 455.00",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(-3528.00, 0.00)",
    id: "U11_Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3537.82,242.39 C3540.28,236.24 3557.23,205.39 3566.29,190.28 C3571.21,182.40 3581.08,167.58 3586.02,160.67 C3590.97,154.08 3601.86,140.72 3605.82,136.31 C3610.89,130.73 3625.12,118.31 3631.88,113.59 C3638.65,108.89 3651.82,102.00 3659.03,99.30 C3665.82,96.77 3679.37,93.54 3686.13,92.82 C3693.16,92.11 3707.63,93.16 3714.99,94.78 C3722.36,96.44 3736.16,101.59 3744.36,105.57 C3751.63,109.11 3765.00,116.87 3772.95,122.16 C3776.81,124.76 3791.46,136.74 3797.40,141.99 C3803.31,147.47 3817.18,161.31 3820.65,165.17 C3826.13,171.30 3835.81,183.87 3840.01,190.32 C3845.06,198.11 3851.57,211.89 3854.32,219.54 C3857.14,227.46 3860.37,240.65 3862.38,251.98 C3863.56,259.44 3865.69,273.64 3866.47,279.90 C3867.28,287.27 3867.11,301.61 3866.12,307.02 C3865.58,309.83 3863.57,314.50 3861.46,317.72 C3856.75,324.80 3847.85,334.17 3839.95,341.47 C3829.18,351.02 3796.80,377.86 3787.95,383.99 C3780.81,388.92 3766.86,397.14 3760.05,400.43 C3752.70,403.95 3737.19,409.01 3729.41,410.46 C3721.63,411.88 3707.29,412.36 3699.22,411.53 C3691.83,410.74 3677.08,407.66 3669.71,405.37 C3661.58,402.82 3647.85,396.76 3640.98,393.06 C3633.92,389.25 3620.69,380.80 3612.69,374.99 C3605.96,369.90 3593.20,360.03 3587.17,355.24 C3581.67,350.67 3571.64,342.06 3564.00,333.39 C3557.94,326.47 3551.76,317.46 3546.43,308.60 C3543.19,302.95 3538.03,293.35 3535.32,285.58 C3534.28,282.58 3532.07,275.09 3531.80,273.91 C3531.12,270.78 3531.49,263.47 3532.55,258.76 C3533.68,253.85 3536.79,244.98 3537.82,242.39 Z",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeWidth: 10,
    strokeOpacity: 1,
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgU11, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/U-11.4b61ab34.svg";
export { ForwardRef as ReactComponent };